export function ensureObjectOrNull(object: any) {
  if (!object) {
    return null;
  }

  if (!object.id) {
    return null;
  }

  if (!object.__type) {
    return {
      id: object.id,
    };
  }

  return {
    id: object.id,
    __type: object.__type,
  };
}
